export const GET_DEALNAMES = "GET_DEALNAMES";
export const GET_DEALNAME_UPDATE = "GET_DEALNAME_UPDATE";
export const COPY_DEALNAME = "COPY_DEALNAME"